import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';
import { Directive, ElementRef, forwardRef, OnInit } from '@angular/core';

import { noWhitespaces } from './validator';

@Directive({
  selector: '[noWhitespaces]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => NoWhitespacesValidatorDirective),
    multi: true
  }]
})
export class NoWhitespacesValidatorDirective implements Validator {
    constructor(private el: ElementRef) { }

    private validator: ValidatorFn;
  
    ngOnInit() {
        this.validator = noWhitespaces();
    }
  
    validate(c: AbstractControl): { [key: string]: any } {
        return this.validator(c);
    }
}
